/**
 * Stamp of this build, replaced by vite (`define` in vite.config.js).
 *
 * It goes in the address of the files that keep their name forever — the car's catalogue
 * (public/cars/*.json) and its sprites: without it a deploy is answered by the copy the browser
 * already has, and a livery added today stays invisible until that copy expires.
 */
export const BUILD_STAMP = __BUILD_STAMP__
